import amexLogo from '@/images/card-brands/amex.svg';
import dinersLogo from '@/images/card-brands/diners.svg';
import discoverLogo from '@/images/card-brands/discover.svg';
import genericLogo from '@/images/card-brands/generic.svg';
import jcbLogo from '@/images/card-brands/jcb.svg';
import mastercardLogo from '@/images/card-brands/mastercard.svg';
import visaLogo from '@/images/card-brands/visa.svg';

export interface CardBrandIcon {
  node: React.ReactNode;
  label: string;
}

const CARD_BRAND_LOGOS: Record<string, { src: string; label: string }> = {
  visa: { src: visaLogo, label: 'Visa' },
  mastercard: { src: mastercardLogo, label: 'Mastercard' },
  amex: { src: amexLogo, label: 'American Express' },
  discover: { src: discoverLogo, label: 'Discover' },
  diners: { src: dinersLogo, label: 'Diners Club' },
  jcb: { src: jcbLogo, label: 'JCB' },
};

const DEFAULT_CARD_LOGO = { src: genericLogo, label: 'Credit Card' };

export function getCardBrandIcon(brand: string): CardBrandIcon {
  const logo = CARD_BRAND_LOGOS[brand.toLowerCase()] ?? DEFAULT_CARD_LOGO;

  return {
    node: (
      <div className="flex h-8 w-[46px] shrink-0 items-center justify-center overflow-hidden rounded-sm border border-border bg-background">
        <img src={logo.src} alt={logo.label} className="h-full w-full object-cover" />
      </div>
    ),
    label: logo.label,
  };
}
